import { render, staticRenderFns } from "./ContactRelationAdd.vue?vue&type=template&id=6195ecf3&"
import script from "./ContactRelationAdd.vue?vue&type=script&lang=js&"
export * from "./ContactRelationAdd.vue?vue&type=script&lang=js&"
import style0 from "./ContactRelationAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports